import {
	createFormProps,
	customValueTypes,
	fieldsGroupType,
	fieldType,
	validationTypes,
} from 'components/FormCreatorComponent/types';
import { getAllDays, getAllMonths, getYears } from 'components/FormCreatorComponent/helpers';
import { fieldMode } from 'components/FormCreatorComponent/types';
import {
	AccountEntityType,
	accountMaxForPaymentAndConvert,
	expectedAnnualPaymentsVolumeOptions,
	expectedMonthlyPaymentsCountOptions,
	newAccountsSteps,
} from 'constants/new_accounts.constants';
import { countryId } from 'constants/user.constants';
import { formConfig } from 'sections/pendingRequests/forms.types';
import { getFile } from 'services/global.service';
import { isValidCityName } from 'utils/new-accounts.utils';
import { incorporationDateGroups } from 'sections/NewAccounts/forms.types';
import BusinessWebsiteField from 'sections/NewAccounts/components/BusinessWebsiteField';
import { ExpectedPaymentCountriesFormField } from 'sections/NewAccounts/components/ExpectedPaymentCountriesPicker';

export const overrideNewAccountFormsToCreate: Record<string, Partial<createFormProps>> = {
	[newAccountsSteps.CUSTOMER_DETAILS as string]: [
		{
			handleChange: () => {},
			fieldsGroups: [
				{
					type: fieldsGroupType.col,
					fields: [
						{
							type: fieldType.text,
							mode: fieldMode.write,
							props: {
								name: 'accountNameEnglish',
								label: 'page.accounts.customer_details.accountNameEnglish',
								required: true,
								disabled: false,
							},
							validation: [{ requierd: true }, { [validationTypes.latinLettersSpecialChars]: true }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.write,
							props: {
								name: 'accountNameHebrew',
								label: 'page.accounts.customer_details.accountNameHebrew',
								required: true,
								disabled: false,
							},
							validation: [{ requierd: true }, { [validationTypes.hebrewLettersSpecialChars]: true }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.write,
							props: {
								name: 'hyperAccountNumber',
								label: 'page.accounts.customer_details.hyper_number',
								required: true,
								disabled: false,
							},
							validation: [{ requierd: true }, { [validationTypes.integer]: true }],
						},
					],
				},
				{
					type: fieldsGroupType.row,
					fields: [
						{
							type: fieldType.radio,
							mode: fieldMode.write,
							props: {
								name: 'entityType',
								label: 'page.accounts.new_account.customer.customer_identification.title',
								options: [
									{ value: 'COMPANY', label: 'customer.type.individual', disabled: false },
									{ value: 'CORPORATION', label: 'customer.type.corporate', disabled: false },
								],
								required: true,
								disabled: false,
							},
							validation: [{ requierd: true }],
						},
					],
				},
				{
					type: fieldsGroupType.col,
					fields: [
						{
							type: fieldType.text,
							mode: fieldMode.write,
							props: {
								name: 'identityNumber',
								label: 'label.identificationNumber.corporate',
								required: true,
								disabled: false,
							},
							validation: [
								{ requierd: true },
								{ [validationTypes.digitsOnly]: true },
								// {
								// 	[validationTypes.custom]: {
								// 		function: (value: string) => value.length === 9,
								// 		errorText: 'validations.errors.identificationNumber',
								// 	},
								// },
							],
							dependency: { name: 'entityType', value: AccountEntityType.CORPORATION },
						},
						{
							type: fieldType.text,
							mode: fieldMode.write,
							props: {
								name: 'identityNumber',
								label: 'label.identificationNumber.company',
								required: true,
								disabled: false,
							},
							validation: [
								{ requierd: true },
								{ [validationTypes.digitsOnly]: true },
								// {
								// 	[validationTypes.custom]: {
								// 		function: (value: string) => value.length === 9,
								// 		errorText: 'validations.errors.identificationNumber',
								// 	},
								// },
							],
							dependency: { name: 'entityType', value: AccountEntityType.COMPANY },
						},
					],
				},
				...incorporationDateGroups(fieldMode.write),
				{
					type: fieldsGroupType.row,
					title: 'page.accounts.new_account.customer.address_hebrew.title',
					fields: [
						{
							type: fieldType.text,
							mode: fieldMode.write,
							props: {
								name: 'countryId',
								label: 'label.country',
								options: [],
								required: true,
								disabled: true,
							},
							validation: [{ requierd: true }],
							customValue: () => 'ישראל',
						},
						{
							type: fieldType.text,
							mode: fieldMode.write,
							props: {
								name: 'cityHebrew',
								label: 'page.accounts.user_details.city',
								required: true,
								disabled: false,
							},
							validation: [{ requierd: true }, { [validationTypes.hebrewLettersSpecialChars]: true }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.write,
							props: {
								name: 'zipCode',
								label: 'label.postalCode',
								required: true,
								disabled: false,
							},
							validation: [{ requierd: true }, { [validationTypes.digitsOnly]: true }],
						},
					],
				},
				{
					type: fieldsGroupType.row,
					fields: [
						{
							type: fieldType.text,
							mode: fieldMode.write,
							props: {
								name: 'addressHebrew',
								label: 'page.accounts.customer_details.street_number_hebrew',
								required: true,
								disabled: false,
							},
							validation: [{ requierd: true }, { [validationTypes.hebrewLettersSpecialChars]: true }],
						},
					],
				},
				{
					type: fieldsGroupType.row,
					title: 'page.accounts.new_account.customer.address_english.title',
					fields: [
						{
							type: fieldType.text,
							mode: fieldMode.write,
							props: {
								name: 'countryId',
								label: 'label.country',
								options: [],
								required: true,
								disabled: true,
							},
							validation: [{ requierd: true }],
							customValue: () => 'Israel',
						},
						{
							type: fieldType.text,
							mode: fieldMode.write,
							props: {
								name: 'cityEnglish',
								label: 'page.accounts.user_details.city',
								required: true,
								disabled: false,
							},
							validation: [
								{ requierd: true },
								{ [validationTypes.latinLettersSpecialChars]: true },
								{
									[validationTypes.custom]: {
										function: isValidCityName,
										errorText: 'validations.errors.city',
									},
								},
							],
						},
						{
							type: fieldType.text,
							mode: fieldMode.write,
							props: {
								name: 'zipCode',
								label: 'label.postalCode',
								required: true,
								disabled: false,
							},
							validation: [{ requierd: true }, { [validationTypes.digitsOnly]: true }],
						},
					],
				},
				{
					type: fieldsGroupType.row,
					fields: [
						{
							type: fieldType.text,
							mode: fieldMode.write,
							props: {
								name: 'addressEnglish',
								label: 'page.accounts.customer_details.street_number_english',
								required: true,
								disabled: false,
							},
							validation: [{ requierd: true }, { [validationTypes.latinLettersSpecialChars]: true }],
						},
					],
				},
				{
					type: fieldsGroupType.col,
					title: 'page.accounts.new_account.customer.business_profile.title',
					fields: [
						{
							type: fieldType.select,
							mode: fieldMode.write,
							ListboxProps: { dir: 'rtl' },
							props: {
								name: 'industryId',
								label: 'page.accounts.new_account.customer.industry',
								options: [],
								required: true,
								disabled: false,
							},
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.custom,
							mode: fieldMode.write,
							props: {
								name: 'businessWebsiteUrl',
								label: 'page.accounts.new_account.customer.business_website',
								required: true,
								disabled: false,
								customComponent: BusinessWebsiteField,
							},
							validation: [{ requierd: true }],
						},
					],
				},
				{
					type: fieldsGroupType.col,
					fields: [
						{
							type: fieldType.text,
							mode: fieldMode.write,
							props: {
								name: 'maxForPayment',
								label: 'label.maxForPayment',
								disabled: false,
							},
							suffix: '$',
							validation: [
								{ requierd: true },
								{ [validationTypes.integer]: true },
								{ maxNumber: accountMaxForPaymentAndConvert },
							],
							customValueType: customValueTypes.integer,
						},
						{
							type: fieldType.text,
							mode: fieldMode.write,
							props: {
								name: 'maxForConvert',
								label: 'label.maxForConvert',
								disabled: false,
							},
							suffix: '$',
							validation: [
								{ requierd: true },
								{ [validationTypes.integer]: true },
								{ maxNumber: accountMaxForPaymentAndConvert },
							],
							customValueType: customValueTypes.integer,
						},
					],
				},
				{
					type: fieldsGroupType.col,
					title: 'page.accounts.new_account.customer.expected_activity.title',
					fields: [
						{
							type: fieldType.select,
							mode: fieldMode.write,
							ListboxProps: { dir: 'rtl' },
							props: {
								name: 'expectedAnnualPaymentsVolume',
								label: 'page.accounts.new_account.customer.expected_annual_payments_volume',
								options: expectedAnnualPaymentsVolumeOptions,
								required: true,
								disabled: false,
							},
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.select,
							mode: fieldMode.write,
							ListboxProps: { dir: 'rtl' },
							props: {
								name: 'expectedMonthlyPaymentsCount',
								label: 'page.accounts.new_account.customer.expected_monthly_payments_count',
								options: expectedMonthlyPaymentsCountOptions,
								required: true,
								disabled: false,
							},
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.custom,
							mode: fieldMode.write,
							props: {
								name: 'expectedPaymentCountryIds',
								label: 'page.accounts.new_account.customer.expected_payment_countries',
								required: true,
								disabled: false,
								customComponent: ExpectedPaymentCountriesFormField,
							},
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.select,
							mode: fieldMode.write,
							ListboxProps: { dir: 'rtl' },
							props: {
								name: 'expectedPaymentCurrencyId',
								label: 'page.accounts.new_account.customer.expected_payment_currency',
								options: [],
								required: true,
								disabled: false,
							},
							validation: [{ requierd: true }],
						},
					],
				},
				{
					type: fieldsGroupType.row,
					title: 'page.accounts.new_account.customer.client_risk_level',
					fields: [
						{
							type: fieldType.select,
							mode: fieldMode.write,
							ListboxProps: { dir: 'rtl' },
							props: {
								name: 'riskLevel',
								label: 'page.accounts.new_account.customer.client_risk_level',
								options: [
									{ value: 'low', label: 'נמוך' },
									{ value: 'medium', label: 'בינוני' },
									{ value: 'high', label: 'גבוהה' },
									{ value: 'veryHigh', label: 'גבוהה מאוד' },
								],
								required: true,
								disabled: false,
							},
							validation: [{ requierd: true }],
						},
					],
				},
				{
					type: fieldsGroupType.col,
					fields: [
						{
							type: fieldType.select,
							mode: fieldMode.write,
							ListboxProps: { dir: 'rtl' },
							props: {
								name: 'customerSuccessManagerId',
								label: 'page.customerAccounts.basicData.manager',
								options: [],
								required: false,
								disabled: false,
							},
						},
						{
							type: fieldType.select,
							mode: fieldMode.write,
							ListboxProps: { dir: 'rtl' },
							props: {
								name: 'agentId',
								label: 'page.customerAccounts.basicData.agent',
								options: [],
								required: false,
								disabled: false,
							},
						},
						{
							type: fieldType.select,
							mode: fieldMode.write,
							ListboxProps: { dir: 'rtl' },
							props: {
								name: 'dealerId',
								label: 'page.customerAccounts.basicData.dealer',
								options: [],
								required: false,
								disabled: false,
							},
						},
						{
							type: fieldType.select,
							mode: fieldMode.write,
							ListboxProps: { dir: 'rtl' },
							props: {
								name: 'leadId',
								label: 'page.customerAccounts.basicData.lead',
								options: [],
								required: false,
								disabled: false,
							},
						},
					],
				},
			],
		},
	],
	[newAccountsSteps.USER_DETAILS as string]: [
		{
			name: 'page.managePendingRequests.forms.account',
			handleChange: () => {},
			fieldsGroups: [
				{
					type: fieldsGroupType.col,
					fields: [
						{
							type: fieldType.text,
							mode: fieldMode.write,
							props: {
								name: 'firstNameHebrew',
								label: 'label.firstNameHebrew',
								required: true,
								disabled: false,
							},
							validation: [{ requierd: true }, { [validationTypes.hebrewLettersOnly]: true }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.write,
							props: {
								name: 'lastNameHebrew',
								label: 'label.lastNameHebrew',
								required: true,
								disabled: false,
							},
							validation: [{ requierd: true }, { [validationTypes.hebrewLettersOnly]: true }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.write,
							props: {
								name: 'firstNameEnglish',
								label: 'label.firstNameEnglish',
								required: true,
								disabled: false,
							},
							validation: [{ requierd: true }, { [validationTypes.latinLettersOnly]: true }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.write,
							props: {
								name: 'lastNameEnglish',
								label: 'label.lastNameEnglish',
								required: true,
								disabled: false,
							},
							validation: [{ requierd: true }, { [validationTypes.latinLettersOnly]: true }],
						},
					],
				},
				{
					type: fieldsGroupType.row,
					title: 'label.birthDate',
					fields: [
						{
							type: fieldType.select,
							mode: fieldMode.write,
							props: {
								name: 'day',
								label: 'label.day',
								options: getAllDays(),
								required: true,
								disabled: false,
							},
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.select,
							mode: fieldMode.write,
							props: {
								name: 'month',
								label: 'label.month',
								options: getAllMonths(),
								required: true,
								disabled: false,
							},
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.select,
							mode: fieldMode.write,
							props: {
								name: 'year',
								label: 'label.year',
								options: getYears(),
								required: true,
								disabled: false,
							},
							validation: [{ requierd: true }],
						},
					],
				},
				{
					type: fieldsGroupType.row,
					fields: [
						{
							type: fieldType.radio,
							mode: fieldMode.write,
							props: {
								name: 'legalStatus',
								label: 'label.publicFigure',
								options: [
									{ value: 'Legal', label: 'label.yes', disabled: false },
									{ value: 'NotLegal', label: 'label.no', disabled: false },
								],
								required: true,
								disabled: false,
							},
							validation: [{ requierd: true }],
						},
					],
				},
				{
					type: fieldsGroupType.row,
					fields: [
						{
							type: fieldType.radio,
							mode: fieldMode.write,
							props: {
								name: 'identificationType',
								label: 'label.identificationType',
								options: [
									{ value: 'ID', label: 'label.identicationId', disabled: false },
									{ value: 'Passport', label: 'label.passport', disabled: false },
								],
								required: true,
								disabled: false,
							},
							validation: [{ requierd: true }],
						},
					],
				},
				{
					type: fieldsGroupType.row,
					fields: [
						{
							type: fieldType.text,
							mode: fieldMode.write,
							props: {
								name: 'identificationNumber',
								label: 'page.accounts.new_account.customer.customer_identification.title',
								required: true,
								disabled: false,
							},
							validation: [
								{ requierd: true },
								{ [validationTypes.digitsOnly]: true },
								{
									[validationTypes.custom]: {
										function: (value: string) => value.length < 10,
										errorText: 'validations.errors.userIdentificationNumber',
									},
								},
							],
						},
					],
				},
				/*
				{
					type: fieldsGroupType.col,
					fields: [
						{
							type: fieldType.radio,
							mode: fieldMode.write,
							props: {
								name: 'gender',
								label: 'label.gender',
								options: [
									{ value: 'Male', label: 'label.male', disabled: false },
									{ value: 'Female', label: 'label.female', disabled: false },
								],
								required: true,
								disabled: false,
							},
							validation: [{ requierd: true }],
						},
					],
				},
				*/
			],
		},
		{
			name: 'page.managePendingRequests.forms.contact',
			handleChange: () => {},
			fieldsGroups: [
				{
					type: fieldsGroupType.col,
					fields: [
						{
							type: fieldType.text,
							mode: fieldMode.write,
							props: {
								name: 'emailAddress',
								label: 'label.email',
								required: true,
								disabled: false,
							},
							validation: [{ requierd: true }, { email: true }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.write,
							props: {
								name: 'phoneNumber',
								label: 'label.phone',
								required: true,
								disabled: false,
							},
							validation: [{ requierd: true }, { phone: true }],
						},
						/*
						{
							type: fieldType.text,
							mode: fieldMode.write,
							props: {
								name: 'address',
								label: 'label.address',
								required: true,
								disabled: false,
							},
							validation: [{ requierd: true }, { [validationTypes.hebrewLettersSpecialChars]: true }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.write,
							props: {
								name: 'city',
								label: 'label.city',
								required: true,
								disabled: false,
							},
							validation: [{ requierd: true }, { [validationTypes.hebrewLettersOnly]: true }],
						},
						{
							type: fieldType.select,
							mode: fieldMode.readonly,
							props: {
								name: 'countryId',
								label: 'label.country',
								required: true,
								disabled: false,
								options: [{ value: countryId, label: 'Israel' }],
							},
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.select,
							mode: fieldMode.readonly,
							props: {
								name: 'birthCountryId',
								label: 'label.birthCountryId',
								required: true,
								disabled: false,
							},
							validation: [{ requierd: true }],
						},
						*/
					],
				},
			],
		},
		{
			name: 'page.managePendingRequests.forms.manageAccountDetails',
			handleChange: () => {},
			fieldsGroups: [
				{
					type: fieldsGroupType.col,
					fields: [
						{
							type: fieldType.text,
							mode: fieldMode.write,
							props: {
								name: 'role',
								label: 'label.role',
								disabled: false,
							},
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.select,
							mode: fieldMode.write,
							props: {
								name: 'permission',
								label: 'label.permisionLevel',
								options: [
									{ label: 'label.Signer', value: 'Signer' },
									{ label: 'label.Operationer', value: 'Operationer' },
									{ label: 'label.Viewer', value: 'Viewer' },
								],
								required: true,
								disabled: false,
							},
							validation: [{ requierd: false }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.write,
							props: {
								name: 'maxForPayment',
								label: 'label.maxForPayment',
								disabled: false,
								helperText: '',
							},
							suffix: '$',
							validation: [{ requierd: true }, { [validationTypes.integer]: true }],
							customValueType: customValueTypes.integer,
						},
						{
							type: fieldType.text,
							mode: fieldMode.write,
							props: {
								name: 'maxForConvert',
								label: 'label.maxForConvert',
								disabled: false,
							},
							suffix: '$',
							validation: [{ requierd: true }, { [validationTypes.integer]: true }],
							customValueType: customValueTypes.integer,
						},
					],
				},
			],
		},
	],
	[newAccountsSteps.BANK_ACCOUNT_DETAILS as string]: [
		{
			name: 'page.managePendingRequests.forms.bank',
			handleChange: () => {},
			fieldsGroups: [
				{
					type: fieldsGroupType.col,
					fields: [
						{
							type: fieldType.text,
							mode: fieldMode.write,
							props: {
								name: 'accountOwnerName',
								label: 'page.pendingRequests.field.accountOwnerName',
								required: true,
								disabled: false,
							},
							validation: [{ requierd: true }, { [validationTypes.address]: true }],
						},
						{
							type: fieldType.select,
							mode: fieldMode.write,
							props: {
								name: 'bankId',
								label: 'page.pendingRequests.field.bankName',
								options: [],
								required: true,
								disabled: false,
							},
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.write,
							props: {
								name: 'bankBranch',
								label: 'page.pendingRequests.field.bankBranch',
								required: true,
								disabled: false,
							},
							validation: [{ requierd: true }, { [validationTypes.integer]: true }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readWithEnableWrite,
							props: {
								name: 'accountNumber',
								label: 'page.pendingRequests.field.accountNumber',
								required: true,
								disabled: false,
							},
							validation: [{ requierd: true }, { [validationTypes.integer]: true }],
						},
					],
				},
			],
		},
		{
			name: 'page.managePendingRequests.forms.approveAccount',
			handleChange: () => {},
			fieldsGroups: [
				{
					type: fieldsGroupType.col,
					fields: [
						{
							type: fieldType.file,
							mode: fieldMode.write,
							props: {
								name: 'file',
								label: 'page.pendingRequests.field.fileReference',
								required: true,
								disabled: false,
								onClick: (file) => {
									getFile(file?.key);
								},
							},
							validation: [{ requierd: true }],
						},
					],
				},
			],
		},
	],
};
